import React from 'react';
import './InsuranceTaxiPage.css';

const InsuranceTestimonialsSection = () => {
  return (
    <div className="InsuranceTestimonialsSection">
      <h2 className="InsuranceTestimonialsTitle">לקוחות ממליצים</h2>
      <div className="InsuranceTestimonialsGrid">

        <div className="InsuranceTestimonialCard">
          <p className="InsuranceTestimonialText">
            "משה ציון הציל אותי! אחרי תאונה, טיפל בהכל במהירות ועם שירות מדהים. ממליץ לכולם."
          </p>
          <div className="InsuranceTestimonialAuthor">
            <span className="InsuranceTestimonialName">יוסי כהן</span>
            <span className="InsuranceTestimonialRating">⭐⭐⭐⭐⭐</span>
          </div>
        </div>

        <div className="InsuranceTestimonialCard">
          <p className="InsuranceTestimonialText">
            "פוליסה משתלמת, הסבר מפורט בלי כאב ראש – סוף סוף מישהו שמבין נהגים!"
          </p>
          <div className="InsuranceTestimonialAuthor">
            <span className="InsuranceTestimonialName">מוחמד עיסא</span>
            <span className="InsuranceTestimonialRating">⭐⭐⭐⭐⭐</span>
          </div>
        </div>

        <div className="InsuranceTestimonialCard">
          <p className="InsuranceTestimonialText">
            "כבר 3 שנים איתו – לא מחליף את משה ציון באף סוכן אחר!"
          </p>
          <div className="InsuranceTestimonialAuthor">
            <span className="InsuranceTestimonialName">אלי לוי</span>
            <span className="InsuranceTestimonialRating">⭐⭐⭐⭐⭐</span>
          </div>
        </div>

        <div className="InsuranceTestimonialCard">
          <p className="InsuranceTestimonialText">
            "שירות מעולה, תגובה מהירה, וסוכן שממש מבין את העולם של המוניות."
          </p>
          <div className="InsuranceTestimonialAuthor">
            <span className="InsuranceTestimonialName">אורן פרץ</span>
            <span className="InsuranceTestimonialRating">⭐⭐⭐⭐⭐</span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default InsuranceTestimonialsSection;
